<div class="custom-mat-dialog-form">
  <h5>{{ isEditing ? 'Edit' : 'Add' }} Energy Consumption Report Configuration</h5>
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="mt-2">
      <label for="controllerType">Controller type</label>
      <mat-select id="controllerType" class="form-control" formControlName="controllerType" [disabled]="isEditing">
        @for (controllerType of controllerTypes; track controllerType.BK) {
          <mat-option [value]="controllerType.BK">{{ controllerType.Description }}</mat-option>
        }
      </mat-select>

      <br />
      <mat-checkbox formControlName="enable">Enabled</mat-checkbox>

      <br />
      <label for="sendInterval">Send interval</label>
      <mat-select id="sendInterval" class="form-control" formControlName="sendInterval">
        <mat-option value="daily">Daily</mat-option>
        <mat-option value="hourly">Hourly</mat-option>
        <mat-option value="direct">Direct</mat-option>
      </mat-select>

      <br />
      <label for="reportingInterval">Reporting interval</label>
      <mat-select id="reportingInterval" class="form-control" formControlName="reportingInterval">
        <mat-option [value]="15">15</mat-option>
        <mat-option [value]="60">60</mat-option>
      </mat-select>
    </div>

    <div class="mt-2 right">
      <button type="button" class="btn btn-danger" (click)="onNoClick()">Cancel</button>
      <button type="submit" class="btn btn-primary" [disabled]="form.invalid">Save</button>
    </div>
  </form>
</div>